import {Component, OnDestroy, OnInit} from '@angular/core';
import {SEOService} from '../../shared/services/seo.service';
import {PagesService} from '../../shared/services/pages.service';
import {Observable, Subject} from 'rxjs';
import {CmsService} from '../../cms/services/cms.service';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-cookie-page',
  templateUrl: './cookie-page.component.html',
  styleUrls: ['./cookie-page.component.scss']
})
export class CookiePageComponent implements OnInit, OnDestroy {

  cookie$: Observable<string>;
  private unsubscribe$ = new Subject<any>();

  constructor(private _seoService: SEOService,
              private _pagesService: PagesService,
              private _cmsService: CmsService) {
  }

  ngOnInit(): void {
    this._seoService.setTitle('Cookie Policy');
    this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(siteUrl => {
      if (siteUrl) {
        this.cookie$ = this._pagesService.getCookie(siteUrl);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

}
